import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TrackingEventTypes } from "@cinch-nx/shared-analytics";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { StoryblokIcon } from "../icon/icon";
import styles from "./usp-slide.module.css";
import { datadogRum } from "@datadog/browser-rum";
import { Datadog } from "@cinch-nx/landing-ui-shared";
import { useAnalytics } from "@cinch-nx/shared-analytics";
var Context = Datadog.Context, Actions = Datadog.Actions;
export function UspSlide(blok) {
    var trackEvent = useAnalytics().trackEvent;
    var title = blok.title, text = blok.text, icon = blok.icon, link = blok.link;
    var handleTrackEvent = function() {
        datadogRum.addAction(Actions.CLICK_USP_LINK, {
            service: Context.HERO_USP,
            squad: Context.SQUAD,
            page: "/",
            category: "hero",
            label: "usp-click - below main hero",
            value: "".concat(title, " usp-click")
        });
        trackEvent({
            eventName: "".concat(title, " usp-click"),
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "hero",
                    label: "below main hero",
                    action: "".concat(title)
                }
            }
        });
    };
    return /*#__PURE__*/ _jsxs("a", _object_spread_props(_object_spread({
        href: link.url,
        className: styles.slideCard
    }, storyblokEditable(blok)), {
        onClick: function() {
            return handleTrackEvent();
        },
        children: [
            /*#__PURE__*/ _jsx(StoryblokIcon, {
                iconName: icon,
                color: "primary-purple",
                size: 24
            }),
            /*#__PURE__*/ _jsx("h3", {
                children: title
            }),
            /*#__PURE__*/ _jsx("p", {
                children: text
            })
        ]
    }));
}
